/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ResourceTagFromJSON, ResourceTagToJSON, } from './ResourceTag';
/**
 * Check if a given object implements the CampaignWrapperRequest interface.
 */
export function instanceOfCampaignWrapperRequest(value) {
    var isInstance = true;
    return isInstance;
}
export function CampaignWrapperRequestFromJSON(json) {
    return CampaignWrapperRequestFromJSONTyped(json, false);
}
export function CampaignWrapperRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ResourceTagFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'campaigns': !exists(json, 'campaigns') ? undefined : json['campaigns']
    };
}
export function CampaignWrapperRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(ResourceTagToJSON)),
        'name': value.name,
        'campaigns': value.campaigns
    };
}
